var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-title",class:_vm.padding},[_c('h2',{staticClass:"section-title__headline",domProps:{"innerHTML":_vm._s(_vm.sectionTitle.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }